// removed by extract-text-webpack-plugin
module.exports = {"footer-link":"AjX7","icon":"_1l50","text":"fFLa"};


//////////////////
// WEBPACK FOOTER
// ./src/components/FooterList/FooterList.styl
// module id = 79
// module chunks = 0